import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

export function OrderDetailsCards({ order, formatDate }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <Card className="card-dashboard">
        <CardHeader>
          <CardTitle className="text-lg font-heading uppercase">Customer Details</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <p><strong>Name:</strong> {order.customer_name}</p>
          <p><strong>Code:</strong> {order.customer_code}</p>
          {order.customer_address && <p><strong>Address:</strong> {order.customer_address}</p>}
          {order.customer_contact_person && <p><strong>Contact:</strong> {order.customer_contact_person}</p>}
          {order.customer_contact_email && <p><strong>Email:</strong> {order.customer_contact_email}</p>}
          {order.customer_gst && <p><strong>GST:</strong> {order.customer_gst}</p>}
          {order.ship_to_address && (
            <div className="pt-2 border-t mt-2" data-testid="order-ship-to-block">
              <p className="font-semibold text-slate-700 uppercase text-xs tracking-wider mb-1">Ship To</p>
              <p className="whitespace-pre-wrap text-sm">{order.ship_to_address}</p>
            </div>
          )}
        </CardContent>
      </Card>

      <Card className="card-dashboard">
        <CardHeader>
          <CardTitle className="text-lg font-heading uppercase">Order Details</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2">
          <p><strong>Order Date:</strong> {formatDate(order.created_at)}</p>
          {order.customer_po_number && <p><strong>Customer PO:</strong> {order.customer_po_number}</p>}
          {order.customer_po_date && <p><strong>PO Date:</strong> {formatDate(order.customer_po_date)}</p>}
          <p><strong>Quotation Ref:</strong> {order.quotation_number}</p>
          <p><strong>Currency:</strong> {order.currency} {order.currency !== 'INR' && `(Rate: ${order.exchange_rate})`}</p>
          {order.incoterms && <p><strong>Incoterms:</strong> {order.incoterms}</p>}
          <div className="flex items-center gap-2"><strong>Status:</strong> <Badge className="badge-success">{order.status}</Badge></div>
        </CardContent>
      </Card>
    </div>
  );
}
